module.exports = __webpack_public_path__ + "img/right_arrow.223357f1.svg";